import type { Level } from "@app-types/activity-data.types";

export const levelDetails: Record<
  Level,
  { label: string; description: string }
> = {
  beginner: {
    label: "Beginner",
    description:
      "Step-by-step instructions with templates, examples, and checklists. Great if this is your first time with this tool or task type.",
  },
  intermediate: {
    label: "Intermediate",
    description:
      "Essential guidance with room to explore. You get the objective, context, and a few tips — but the approach is yours.",
  },
  advanced: {
    label: "Advanced",
    description:
      "The scenario and success criteria only. No hand-holding — ideal if you want to test your instincts and problem-solving.",
  },
};
